import React from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_CUPOS = 200;
const RESTANTES = 17;
const PORCENTAJE = Math.round((TOTAL_CUPOS - RESTANTES) / TOTAL_CUPOS * 100);
export function ScarcityBar() {
  return <div className="mx-auto w-full max-w-sm rounded-2xl border border-red-300/60 bg-red-50 px-4 py-4" data-id="element-211" data-mp="2l3v2qogp2a6w">
      <p className="flex items-center justify-center gap-1.5 text-center text-[12px] font-extrabold uppercase tracking-wide text-red-700 sm:text-sm" data-id="element-212" data-mp="2q2zbxf3mc7x8">
        <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-213" data-mp="2b934difafjb2" />
        Solo quedan {RESTANTES} cupos al precio promocional
      </p>

      <div className="mt-3 h-3.5 w-full overflow-hidden rounded-full bg-red-200" role="progressbar" aria-valuenow={PORCENTAJE} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos ocupados al precio promocional" data-id="element-214" data-mp="226ll9cuxj6sa">
        <div className="h-full rounded-full bg-red-500" style={{
        width: `${PORCENTAJE}%`
      }} data-id="element-215" data-mp="5ds1wn3n88o2" />
      </div>

      <p className="mt-2 text-center text-[11px] font-semibold text-red-700/80 sm:text-xs" data-id="element-216" data-mp="33m3al6t9b9ee">
        {PORCENTAJE}% de los cupos ya fueron tomados · {TOTAL_CUPOS - RESTANTES}/{TOTAL_CUPOS}
      </p>
    </div>;
}